document.addEventListener("DOMContentLoaded", function () {
  // Tabs functionality
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((btn, idx) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach(b => b.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById("tab-" + idx).classList.add("active");
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('.image-product-slider__swiper');
    if (sliderEl) {
        new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            navigation: {
                nextEl: document.querySelector('.image-product-slider .swiper-button-next'),
                prevEl: document.querySelector('.image-product-slider .swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: 1
                }
            }
        });
    }
    const videoSection = document.querySelector('.custom-video-inner.swiper');
    if(videoSection){
        new Swiper(videoSection, {
          loop: true,
          autoplay: {
            delay: 5000,
          },
          slidesPerView: 1,
          navigation: {
            nextEl: videoSection.querySelector('.swiper-button-next'),
            prevEl: videoSection.querySelector('.swiper-button-prev'),
          },
        });
    }
});
class Instagram {
    constructor(){
        this.init();       
    }
    sliderInit = (ele) => {
        let parent = ele.parentNode;
        const swiper = new Swiper(ele, {
            slidesPerView:2,
            breakpoints: {
                768: {
                  slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: parent.querySelector('.swiper-button-next'),
                prevEl: parent.querySelector('.swiper-button-prev'),
            }
        });
    }
    init = () =>{
        let eles = document.querySelectorAll(".custom-instagram-wrap .swiper");
        eles.forEach(ele=>{
            this.sliderInit(ele);
        })
    }
}

new Instagram;
class FeaturedCollection {
    constructor(){
        this.init();       
    }
    sliderInit = (ele) => {
        const swiper = new Swiper(ele, {
            spaceBetween:5,
            slidesPerView:2,
            navigation: {
                nextEl: ele.closest('.collection-main-wrap').querySelector('.swiper-button-next'),
                prevEl: ele.closest('.collection-main-wrap').querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            }
        });
    }
    init = () =>{
        let eles = document.querySelectorAll(".featured-collection-wrap .swiper");
        eles.forEach(ele=>{
            this.sliderInit(ele);
        })
    }
}

new FeaturedCollection;